module.exports = __webpack_public_path__ + "static/media/upload_more.32c67888.svg";